export default class LangToggle {
  constructor() {
    this.nav = document.querySelectorAll('.js-lang')
    this.init()
  }

  init() {
    this.nav.forEach((nav) => {
      const navButton = nav.querySelector('.js-lang__list > li > a')
      const menu = nav.querySelector('.js-lang__list')

      navButton.addEventListener('click', (e) => {
        e.preventDefault()
        menu.classList.toggle('is-opened')
      })

      document.addEventListener('click', (e) => {
        if (!e.target.closest('.js-lang')) {
          menu.classList.remove('is-opened')
        }
      })
    })
  }
}
